export default `vec3 Q=abs(p);
    float a=1., d=1.;
    for(int j=0;j++<9;)
      Q=2.*clamp(Q,-.9,.9)-Q,
      d=dot(Q,Q),
      Q/=d,
      a/=d;
    return (Q.x+Q.z-.6)/a/3.;
  }`